module.exports = __webpack_public_path__ + "img/cross.359b8141.svg";